export default __webpack_public_path__ + "static/media/coam-full-logo.ec258b12.png";